module.exports = __webpack_public_path__ + "img/goldregen-2020-064.ae5a1947.jpg";